import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import WithRender from "@/Pages/Admin/Modules/Hotel/tab/General/Reservation/Views/reservation.html";
import { common } from "@/Pages/Admin/Modules/Common/Services/Common";
import ValidationError from "@/Pages/Admin/Modules/Common/Controllers/ValidationError";
import { hotelService } from "@/Pages/Admin/Modules/Hotel/Services/HotelService";
import { flashService } from "@/Pages/Admin/Modules/Common/Services/FlashMessage/FlashService";
import { HotelModel } from "@/Pages/Admin/Modules/Models/Hotel/HotelModel";
@WithRender
@Component({
  components: {
    "validation-error": ValidationError,
  },
})
export default class Reservation extends Vue {
  protected ui: any = {};
  protected item: any = {};

  constructor() {
    super();

    this.ui = {
      status: {
        isLoading: {
          reservationData: false,
        },
        postLoading: {
          reservationData: false,
        },
        canEdit: false,
      },
      error: {
        errors: {},
        has_error: false,
        error_message: {},
      },
    };

    this.item = {
      reservationData: new HotelModel({}),
      tempReservationData: new HotelModel({}),
    };
  }

  public mounted() {
    this.getReservationData();
  }

  public getReservationData() {
    this.ui.status.isLoading.reservationData = true;
    let data = {
      hotel_id: this.$route.query.id,
    };
    hotelService
      .getReservation(data)
      .then((res: any) => {
        this.item.reservationData = res.data.data;
      })
      .catch((error: any) => {
        this.ui.error.errors = error;
      })
      .finally(() => {
        this.ui.status.isLoading.reservationData = false;
      });
  }

  protected createReservation() {
    this.resetError();
    // if (!this.IsValidationTrue()) {
    //   return;
    // }
    let data = {
      hotel_id: this.$route.query.id,
      currency: this.item.reservationData.currency,
      timezone: this.item.reservationData.timezone,
      is_free_cancel: this.item.reservationData.is_free_cancel,
      is_reservation_without_creadit_card: this.item.reservationData
        .is_reservation_without_creadit_card,
      is_no_prepayment: this.item.reservationData.is_no_prepayment,
      can_exchange_currency: this.item.reservationData.can_exchange_currency,
    };
    this.ui.status.postLoading.addReservation = true;
    hotelService
      .updateReservation(data)
      .then((res: any) => {
        flashService.Success("Reservation Added", res.data.message);
        this.ui.status.canEdit = false;
      })
      .catch((error: any) => {
        common.sdCatchErr(error, this.ui.error.error_message).then((res) => {
          this.ui.error.error_message = res;
        });
        flashService.Error("Error", "Error while adding general reservation.");
      })
      .finally(() => {
        this.ui.status.postLoading.addReservation = false;
      });
  }

  public get buttonName() {
    if (this.ui.status.postLoading.addReservation) {
      return "Processing...";
    }
    return "Save";
  }

  protected onEditReservationClick() {
    this.ui.status.canEdit = true;
    this.item.tempReservationData = Object.assign(
      {},
      this.item.reservationData
    );
  }

  protected cancelReservation() {
    this.ui.status.canEdit = false;
    this.resetError();
    this.item.reservationData = this.item.tempReservationData;
  }

  public resetError() {
    this.ui.error.errors = {};
    this.ui.error.has_error = false;
    this.ui.error.error_message = {};
  }
}
